import React from 'react'
import { Grid, ListItem } from '@material-ui/core'
import {
  EditableSwitch,
  EditableNumericInput,
  // @ts-ignore
} from '../common/EditableComponents'

interface Props {
  label: string
  value: boolean
  editMode: boolean
  onChange: (event: any) => void
  description: string
  type?: 'numeric' | 'switch'
  max?: number
}

const MAX_LIMIT = 1000000 // 1 million max limit for numeric inputs

export const ShopFeatureItem = ({
  label,
  value,
  editMode,
  onChange,
  description,
  type = 'switch',
  max = MAX_LIMIT,
}: Props) => {
  return (
    <ListItem>
      <Grid container>
        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
          {label}
        </Grid>
        <Grid className="editField order_per_month" item xs={12} sm={2} md={2} lg={1}>
          {type === 'switch' && (
            <EditableSwitch
              valueToRender={value ? 'Enabled' : 'Disabled'}
              checked={value}
              editMode={editMode}
              onChange={onChange}
            />
          )}
          {type === 'numeric' && (
            <EditableNumericInput
              material={false}
              valueToRender={value}
              value={value}
              editMode={editMode}
              onChange={(e: number) => onChange({ target: { value: e } })}
              min={0}
              max={max}
              precision={0}
              strict={true}
            />
          )}
        </Grid>
        <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
          <span>{description}</span>
        </Grid>
      </Grid>
    </ListItem>
  )
}



// WEBPACK FOOTER //
// ./src/components/Shops/ShopFeatureItem.tsx